import { useEffect, useState } from 'react';
import ImageLoader from '../ImageLoader';
import { ChevronRightIcon } from '@heroicons/react/24/outline';
import { BottomSheet } from 'react-spring-bottom-sheet';
import { HeaderSlot } from '../../../utils/constants';
import { RelativeHeader } from '../Header';
import ArticleDetail from './Detail';
import { useDispatch, useSelector } from 'react-redux';
import { clearArticle, getListArticle } from '../../../store/reducers/ufood-x/article';
import { isEmptyData } from '../../../utils/helper';


const AllArticle = (props) => {
	const { onClose } = props;
  const { list } = useSelector((store) => store?.article);

	const headerProps = {
		slots: {
			left: {
				content: HeaderSlot.BACK,
				route: onClose,
				className: '!opacity-100 transform !translate-y-0',
			},
			center: {
				content: HeaderSlot.NAME,
				title: 'News & Article',
				className: '!opacity-100 !translate-y-0 ml-2',
			},
		},
		parent: {
			border: {
				bottom: true,
			},
		},
	};
  
	return (
		<>
			<div className='m-4'>
				<RelativeHeader {...headerProps} />
				<div className='grid grid-cols-3 gap-2 mt-4 mb-10'>
					{list?.map((item, index) => {
						return <Article key={index} {...{ item }} />;
					})}
				</div>
			</div>
		</>
	);
};

const Article = (props) => {
	const { item } = props;
	const [isShowBottomSheet, setIsShowBottomSheet] = useState(false);

	const handleCloseBottomSheet = () => {
		setIsShowBottomSheet(false);
	};

	const handleClick = async () => {
		setIsShowBottomSheet(true);
	};

	const articleDetailProps = {
		onClose: handleCloseBottomSheet,
		item,
	};

	return (
		<>
			<div className='flex flex-col' onClick={handleClick}>
				<ImageLoader src={item?.cmspageBannerImage} className='h-[80%] w-full rounded-xl object-cover object-center' />
				<div className='text-xxs font-semibold text-gray-700 pt-2 line-clamp-2 h-full'>{item?.cmspageTitle}</div>
			</div>
			<BottomSheet
				key={'detail-articles'}
				open={isShowBottomSheet}
				onDismiss={handleCloseBottomSheet}
				header={false}
				snapPoints={({ maxHeight }) => {
					return [maxHeight, maxHeight];
				}}>
				<ArticleDetail {...articleDetailProps} />
			</BottomSheet>
		</>
	);
};

const Articles = () => {
	const dispatch = useDispatch();
	const { list } = useSelector((store) => store?.article);
	const [isShowBottomSheet, setIsShowBottomSheet] = useState(false);
	const [page, setPage] = useState(1);
	const [limit, setLimit] = useState(100);

	const handleCloseBottomSheet = () => {
		setIsShowBottomSheet(false);
	};

	const handleClick = async () => {
		setIsShowBottomSheet(true);
	};

	const AllArticleProps = {
		onClose: handleCloseBottomSheet,
	};

	const handleGetListArticle = async () => {
		console.count('handleGetListArticle');
		try {
			dispatch(getListArticle({ page, limit }));
		} catch (error) {
			console.log('error: ', error);
		}
	};

	useEffect(() => {
		dispatch(clearArticle());
	}, []);

	useEffect(() => {
		handleGetListArticle();
	}, []);

	return (
		<>
			<div className={`my-4 ${isEmptyData(list) && 'hidden'}`}>
				<div className='flex justify-between pb-4'>
					<div className='font-semibold text-base text-gray-700'>News & Article</div>
					<div className='font-semibold text-sm text-[var(--rose-violet)] flex items-center gap-1' onClick={handleClick}>
						See all
						<ChevronRightIcon className='h-4 w-auto text-[var(--rose-violet)] text-xxs' strokeWidth={3} />
					</div>
				</div>
				<div className='flex justify-between gap-2'>
					{list?.slice(0, 3)?.map((item, index) => {
						return <Article key={index} {...{ item }} />;
					})}
				</div>
			</div>
			<BottomSheet
				key={'all-articles'}
				open={isShowBottomSheet}
				onDismiss={handleCloseBottomSheet}
				header={false}
				snapPoints={({ maxHeight }) => {
					return [maxHeight, maxHeight];
				}}>
				<AllArticle {...AllArticleProps} />
			</BottomSheet>
		</>
	);
};
export default Articles;
